import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import BreadcrumbDetailed from "components/Common/BreadcrumbDetailed";
import ProductListingPageSidebarTheme2 from "components/ProductListingPageTheme2/SidebarTheme2";
import ProductList from "components/ProductList";
import ProductListingPageActionTheme2 from "components/ProductListingPageTheme2/ActionsTheme2";
import AdsSpaceSectionTheme2 from "./AdsSpaceSectionTheme2";
import AdsSpaceSectionMainTheme2 from "./AdsSpaceSectionMainTheme2";
import { getLocalStorageValue } from "config/helper";
import {
  getHotOffersData,
  getFilterOptionList,
  getProductListByDepartment,
  getDepartmentTree,
  resetFilterSideBar,
  updateIftCheckList,
  updateSearchType,
  updateSearchText,
  emptyIftCheckList,
  updateDepartment,
  getBannerAdsData
} from "redux/actions";
import "./individual-department.scss";

const IndividualDepartmentTheme2 = () => {
  const { departmentSlug } = useParams();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const function_names = searchParams.get("function_names");

  const {
    isUserLoggedIn,
    currentStoreID,
    commonDetailsData: { ecom_section: { sub_department: ecomData } = {} } = {},
    minPriceValue,
    maxPriceValue,
    departmentTree,
    departmentTreeLoading,
    productListByDepartmentTotalCount,
    categoryadsSection,
    productListByDepartmentLoading,
    activePageNo,
    sortByValue,
    iftCheckedList,
    filterOptionList,
    weeklySalesSelected,
    productListByDepartment,
    productListByDepartmentTotalPages,
    filterOptions,
    priceSection,
    bannerAdsData,
    bannerAdsDataLoading,
    searchText,
    memoryToken,
    hotOffersData,
    currentDepartment
  } = useSelector(({ user, store, common, product, bannerAds, search, hotOffers }) => ({
    isUserLoggedIn: user.isUserLoggedIn,
    currentStoreID: store.currentStoreID,
    commonDetailsData: common.commonDetailsData,
    ...product,
    bannerAdsData: bannerAds.bannerAdsData,
    bannerAdsDataLoading: bannerAds.bannerAdsDataLoading,
    searchText: search.searchText,
    hotOffersData: hotOffers.hotOffersData
  }));

  const storeId = currentStoreID || getLocalStorageValue("selected-store-id");
  const clientId = getLocalStorageValue("RSAclient-id");
  const userToken = getLocalStorageValue("user-token");
  const memberNumber = getLocalStorageValue("member-number");
  const lastVisitedPageNo = +getLocalStorageValue("last_visited_page_no");

  const [activeChildIndex, setActiveChildIndex] = useState("");
  const [ready, setReady] = useState(false);
  const [pageLimit, setPageLimit] = useState("");
  const [pageProductCount, setPageProductCount] = useState(0); // Initialize pageProductCount
  const [isMobile, setIsMobile] = useState(window.innerWidth < 769);
  const [filteredBanners, setFilteredBanners] = useState([]);
  const departmentDetails = ecomData?.find((ecom) => ecom.slug === (currentDepartment || departmentSlug));
  //console.log(currentDepartment ?? departmentSlug, departmentSlug, "departmentDetails", departmentDetails);
  const breadcrumbList = [
    { lable: "Department", link: "", searchTag: "" },
    { lable: departmentDetails?.name, link: "", searchTag: "" },
  ];

  const sortByOptionList = filterOptionList.sort_by_section;
  const selectedSortByOption = sortByOptionList?.find((option) => option.sort_id === sortByValue);
  const sortBy = selectedSortByOption?.field_name;

  const listLimitOptionList = filterOptionList.list_limit_section;
  const defaultDropdownValue = listLimitOptionList?.find((option) => option.is_default === "1");
  const { title = "100" } = defaultDropdownValue || {};

  const sortByOption = sortByOptionList?.filter((option) => option.is_visible === "1").map((limit) => ({
    title: limit.title,
    value: limit.sort_id,
  }));

  const listLimitOption = listLimitOptionList?.filter((option) => option.is_visible === "1").map((limit) => ({
    title: limit.title,
    value: limit.title,
  }));

  const updatedDepartmentTree = departmentTree?.filter((fld) => fld.slug === currentDepartment).map((department) => ({
    ...department,
    text: department.name,
  }));

  const updatedOtherDepartmentTree = departmentTree?.filter((fld) => fld.slug !== currentDepartment).map((department) => ({
    ...department,
  }));

  useEffect(() => {
    let urlParams = new URLSearchParams(window.location.search);
    let searchValue = urlParams.get("s");
    dispatch(updateSearchText(searchValue));
  }, [dispatch]);

  useEffect(() => {
    if (departmentSlug) {
      dispatch(updateSearchType(departmentSlug));
    }
    if (departmentSlug && departmentDetails) {
      const { ift, name } = departmentDetails;
      dispatch(updateDepartment(name));
      let iftType = ""
      if (ift === "sales" || ift === "my_favorites") {
        iftType = ift
      }
      if (!weeklySalesSelected) {
        dispatch(emptyIftCheckList([]));
      } else if (iftCheckedList.length === 0) {
        iftType = "sales"
      }
      
      if (iftType) {
        dispatch(updateIftCheckList(iftType));
      }
    }
  }, [departmentSlug, dispatch]);

  useEffect(() => {
    if (!pageProductCount) {
      setPageLimit("100");
    }
  }, [pageProductCount]);

  useEffect(() => {
    return () => {
      dispatch(resetFilterSideBar());
    };
  }, [dispatch]);

  useEffect(() => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
    };
    dispatch(getFilterOptionList(body));
    dispatch(getHotOffersData(body));
  }, [storeId, isUserLoggedIn, clientId, memberNumber, userToken, dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setReady(true);
    }, 10);
    return () => clearTimeout(timer);
  }, [dispatch, departmentDetails, lastVisitedPageNo, activePageNo, minPriceValue, maxPriceValue, storeId, function_names, clientId, isUserLoggedIn, memberNumber, userToken, searchText]);

  useEffect(() => {
    if (ready) {
      getProductListDeptAPICall();
      setReady(false);
    }
  }, [ready]);

  useEffect(() => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      member_number: isUserLoggedIn ? memberNumber : "",
      category_ids: departmentDetails?.category_ids,
      category_name: departmentDetails?.category_ids ? departmentDetails?.name : "",
      search: "",
      funtional_text: "",
      placement: "category-banner-x",
    };
    dispatch(getBannerAdsData(body));
  }, [departmentDetails?.category_ids, clientId, storeId, isUserLoggedIn, memberNumber, dispatch]);

  useEffect(() => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      search: "",
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
      category_ids: departmentDetails?.category_ids,
    };
    dispatch(getDepartmentTree(body));
  }, [storeId, isUserLoggedIn, memberNumber, userToken, departmentDetails, clientId, dispatch]);

  useEffect(() => {
    defaultDropdownValue && setPageLimit(title);
  }, [title, defaultDropdownValue]);

  const getProductListDeptAPICall = () => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
      PageNo: lastVisitedPageNo || activePageNo,
      category_ids: departmentDetails?.category_ids,
      category_name: departmentDetails?.category_ids ? departmentDetails?.name : "",
      ift: iftCheckedList.join("|"),
      limit: pageLimit,
      sort_by: sortBy || "",
      min_price: minPriceValue.toString(),
      max_price: maxPriceValue.toString(),
      funtional_text: "",
      funtional_level: "",
      function_names: function_names || "",
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
      search: searchText || "",
      memoryToken: (lastVisitedPageNo || activePageNo) > 1 ? memoryToken : "",
    };
    dispatch(getProductListByDepartment(body));
  };
  const checkViewportWidth = useCallback(() => {
    setIsMobile(window.innerWidth < 769);
  }, []);

  useEffect(() => {
    checkViewportWidth();
    window.addEventListener('resize', checkViewportWidth);
    return () => {
      window.removeEventListener('resize', checkViewportWidth);
    };
  }, [checkViewportWidth]);

  useEffect(() => {
    setFilteredBanners(bannerAdsData?.ads?.filter(ad => ad.slotId === "Horizontal Banners")[0]?.banners ?? []);
  }, [isMobile, bannerAdsData]);
  return (
    <div className="individual-listing-page">
      {departmentDetails && (
        <BreadcrumbDetailed breadcrumbList={breadcrumbList} title={""} />
      )}
      <div className="container">
        {!productListByDepartmentLoading && !bannerAdsDataLoading && filteredBanners[0] && (
          <AdsSpaceSectionMainTheme2 adsDetails={filteredBanners[0]} isMobile={isMobile} />
        )}
        <div className="individual-listing-page-wrapper">
          <div className="listing-page-wrapper-items">
            <ProductListingPageSidebarTheme2
              priceSection={priceSection}
              departmentTree={updatedDepartmentTree}
              otherDepartmentTree={updatedOtherDepartmentTree}
              iftOptionList={filterOptions}
              maxPriceValue={maxPriceValue}
              minPriceValue={minPriceValue}
              sortByOption={sortByOption}
              listLimitOption={listLimitOption}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              redirectBaseUrl="departments"
              getProductListDeptAPICall={getProductListDeptAPICall}
              departmentSlug={departmentSlug}
              activeChildIndex={activeChildIndex}
              setActiveChildIndex={setActiveChildIndex}
            />
          </div>

          <div className="listing-page-wrapper-items">
            {!productListByDepartmentLoading && (
              <AdsSpaceSectionTheme2
                adsDetails={categoryadsSection}
                department={departmentDetails?.name}
              />
            )}
            <ProductListingPageActionTheme2
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              listLimitOption={listLimitOption}
              sortByOption={sortByOption}
              productListByDepartmentTotalCount={productListByDepartmentTotalCount}
              priceSection={priceSection}
              departmentTree={updatedDepartmentTree}
              otherDepartmentTree={updatedOtherDepartmentTree}
              iftOptionList={filterOptions}
              maxPriceValue={maxPriceValue}
              minPriceValue={minPriceValue}
              redirectBaseUrl="departments"
              departmentTreeLoading={departmentTreeLoading}
              departmentSlug={departmentSlug}
              activeChildIndex={activeChildIndex}
              setActiveChildIndex={setActiveChildIndex}
            />
            {!productListByDepartmentLoading && !bannerAdsDataLoading && (
              <ProductList
                activePageNo={activePageNo}
                productList={productListByDepartment}
                productListByDepartmentTotalPages={productListByDepartmentTotalPages}
                bannerData={filteredBanners[1] ?? {}}
              />
            )}
          </div>
        </div>
        {!productListByDepartmentLoading && !bannerAdsDataLoading && filteredBanners[2] && (
          <AdsSpaceSectionMainTheme2 adsDetails={filteredBanners[2]} isMobile={isMobile} />
        )}
        {/* <HotOffers
          title={hotOfferTitle}
          adverstiseSectionData={adverstiseSectionData}
        /> */}
      </div>
    </div>
  );
};

export default IndividualDepartmentTheme2;